import { styled } from '@linaria/react'
import { TextBoxSC } from 'atoms/TextBox'
import { InputBlockStyled } from 'blocks/InputBlock'
import { FIXED_INDENTS } from 'vars/fixed-indents'

export const ContainerSC = styled.div`
  display: flex;
  flex-direction: column;
`

export const ChangeUsernamePasswordBlockSC = styled.div`
  display: flex;
  flex-direction: column;

  & > ${TextBoxSC} {
    margin-bottom: var(${FIXED_INDENTS.INDENT_60});
  }

  ${InputBlockStyled} {
    margin-bottom: var(${FIXED_INDENTS.INDENT_40});
  }
`
